/* ==========================================================================
   CK | Product Routine
   Slider + selection + bulk add to cart for snippets/ck-routine.liquid.
   Every instance is initialised against its own [data-ck-routine] root and
   all lookups are scoped to it, so if the snippet is ever pasted into two
   PageFly blocks the page degrades to two working sliders instead of one
   broken one.
   ========================================================================== */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 4;

  /* --- Money ---------------------------------------------------------------
     The tiles are priced server-side with Liquid's `money` filter, which
     renders in the ACTIVE MARKET's currency. Rather than guess that from
     shop.money_format (which is the shop's base currency and can differ),
     the snippet ships one real rendered price and we infer the pattern from
     it. That keeps the CTA total identical to the tiles in every market.
     -------------------------------------------------------------------------- */
  function buildFormatter(sample) {
    if (!sample) return null;

    var match = /\d[\d.,'\u00A0 ]*\d|\d/.exec(sample);
    if (!match) return null;

    var core = match[0];
    var formatter = {
      prefix: sample.slice(0, match.index),
      suffix: sample.slice(match.index + core.length),
      decimal: '',
      thousands: '',
      precision: 0
    };

    // A separator followed by exactly two digits at the end is the decimal one.
    if (/[.,](\d{2})$/.test(core)) {
      formatter.decimal = core.charAt(core.length - 3);
      formatter.precision = 2;
    }

    var separators = core.replace(/\d/g, '');
    if (formatter.precision === 2) separators = separators.slice(0, -1);
    formatter.thousands = separators.length ? separators.charAt(0) : '';

    return formatter;
  }

  function applyFormatter(cents, f) {
    var fixed = (cents / 100).toFixed(f.precision);
    var parts = fixed.split('.');
    var whole = f.thousands
      ? parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + f.thousands)
      : parts[0];
    return f.prefix + (parts[1] ? whole + f.decimal + parts[1] : whole) + f.suffix;
  }

  function formatMoney(cents, formatter, currency) {
    if (formatter) {
      try { return applyFormatter(cents, formatter); } catch (e) { /* fall through */ }
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* --- Cart drawer ----------------------------------------------------------
     Reuses the theme's own refresh path from assets/lb.js. Each piece is
     probed before use so a theme change degrades to a cart redirect rather
     than a silent failure.
     -------------------------------------------------------------------------- */
  function openCartDrawer() {
    if (!window.jQuery) return false;
    var $ = window.jQuery;

    // Preferred: let the theme's own handler run, whichever branch it bound
    // (lb.js binds a different one when body has .cart-layer-popup).
    var opener = $('.lb-cart-drawer-opener.lb-header-cart').first();
    if (!opener.length) opener = $('.lb-cart-drawer-opener').first();
    if (opener.length) {
      opener.trigger('click');
      return true;
    }

    // No opener in the DOM: replicate what lb.js does directly.
    var box = $('.lb-cart-drawer-box');
    if (!box.length) return false;
    box.addClass('lb-cart-drawer-box-active');
    $('.lb-cart-drawer-overlay-upper').addClass('lb-cart-drawer-overlay-active');
    if (!$('body').hasClass('cart-layer-popup')) {
      $('html').addClass('all-noscroll');
      $('body').addClass('body-scroll-stop');
    }
    return true;
  }

  function refreshCart() {
    if (typeof window.min_cart === 'function') window.min_cart();
    if (typeof window.cartloader === 'function') window.cartloader();

    if (!openCartDrawer()) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'cart';
    }
  }

  /* --- Instance ------------------------------------------------------------- */
  function initRoutine(root) {
    if (root.dataset.ckInit === '1') return;
    root.dataset.ckInit = '1';

    var track   = root.querySelector('[data-ck-track]');
    var tiles   = Array.prototype.slice.call(root.querySelectorAll('[data-ck-tile]'));
    var prevBtn = root.querySelector('[data-ck-prev]');
    var nextBtn = root.querySelector('[data-ck-next]');
    var cta     = root.querySelector('[data-ck-cta]');
    var ctaLbl  = root.querySelector('[data-ck-cta-label]');
    var errEl   = root.querySelector('[data-ck-error]');

    if (!track || !tiles.length) return;

    var moneyFmt    = buildFormatter(root.getAttribute('data-ck-money-sample') || '');
    var currency    = root.getAttribute('data-ck-currency') || '';
    var ctaAll      = root.getAttribute('data-ck-cta-all') || 'Routine kaufen';
    var ctaPartial  = root.getAttribute('data-ck-cta-partial') || 'Auswahl ({count}) kaufen';
    var cartUrl     = root.getAttribute('data-ck-cart-url') || '/cart/add';
    var txtSelected = root.getAttribute('data-ck-label-selected') || 'Ausgewählt';
    var txtAdd      = root.getAttribute('data-ck-label-add') || 'Hinzufügen';

    /* ---- Selection ---- */
    function selectableTiles() {
      return tiles.filter(function (t) { return t.getAttribute('data-ck-available') === 'true'; });
    }

    function isSelected(tile) {
      return tile.getAttribute('data-ck-selected') === 'true';
    }

    function selectedTiles() {
      return selectableTiles().filter(isSelected);
    }

    function updateCta() {
      if (!cta || !ctaLbl) return;

      var chosen = selectedTiles();
      var pool = selectableTiles();
      var sum = chosen.reduce(function (acc, t) {
        return acc + (parseInt(t.getAttribute('data-ck-price'), 10) || 0);
      }, 0);

      if (!chosen.length) {
        cta.disabled = true;
        ctaLbl.textContent = ctaAll;
        return;
      }

      cta.disabled = false;
      var base = chosen.length === pool.length
        ? ctaAll
        : ctaPartial.replace('{count}', String(chosen.length));

      ctaLbl.textContent = base + ' – ' + formatMoney(sum, moneyFmt, currency);
    }

    function setSelected(tile, on) {
      if (tile.getAttribute('data-ck-available') !== 'true') return;

      tile.setAttribute('data-ck-selected', on ? 'true' : 'false');
      tile.classList.toggle('is-deselected', !on);

      var btn = tile.querySelector('[data-ck-toggle]');
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var lbl = btn.querySelector('[data-ck-toggle-label]');
        if (lbl) lbl.textContent = on ? txtSelected : txtAdd;
      }
      updateCta();
    }

    tiles.forEach(function (tile) {
      var btn = tile.querySelector('[data-ck-toggle]');
      if (!btn || btn.disabled) return;
      btn.addEventListener('click', function () {
        setSelected(tile, !isSelected(tile));
      });
      // Sync the label with the server-rendered state.
      var lbl = btn.querySelector('[data-ck-toggle-label]');
      if (lbl) lbl.textContent = isSelected(tile) ? txtSelected : txtAdd;
    });

    updateCta();

    /* ---- Align rows across tiles ----
       The copy is arbitrary rich text, so its height varies per tile and the
       blocks below it end up at different offsets. Measure the distance from
       each tile's top to the element, then pad the shorter ones down to match
       the tallest. Margins are cleared first so a re-run measures true
       positions rather than compounding. */
    function alignRow(pick) {
      var els = tiles.map(pick).filter(Boolean);
      if (els.length < 2) return;

      els.forEach(function (el) { el.style.marginTop = ''; });

      var offsets = els.map(function (el) {
        var tile = el.closest('[data-ck-tile]');
        return el.getBoundingClientRect().top - tile.getBoundingClientRect().top;
      });

      var tallest = Math.max.apply(null, offsets);

      els.forEach(function (el, i) {
        var delta = tallest - offsets[i];
        if (delta > 0.5) el.style.marginTop = delta + 'px';
      });
    }

    /* Whatever sits directly under the reviews - a check list, a paragraph,
       anything - so tiles line up even when their content differs in kind. */
    function contentAfterReviews(tile) {
      var anchor = tile.querySelector('.ck-routine-rating')
                || tile.querySelector('.ck-routine-product');
      if (!anchor) return null;

      var el = anchor.nextElementSibling;
      while (el && (el.classList.contains('ck-routine-rating') ||
                    el.classList.contains('ck-routine-product'))) {
        el = el.nextElementSibling;
      }

      // The price and button are bottom-anchored by an auto margin; setting a
      // margin-top on them would override it and break that alignment.
      if (!el) return null;
      if (el.classList.contains('ck-routine-price')) return null;
      if (el.classList.contains('ck-routine-toggle')) return null;
      return el;
    }

    /* Document order matters: each row is measured with the rows above it
       already settled, so the image is aligned first, then what follows. */
    function alignRows() {
      alignRow(function (t) { return t.querySelector('.ck-routine-product'); });
      alignRow(contentAfterReviews);
    }

    /* ---- Slider: fit measurement ----
       Measured rather than counted, so it stays correct whatever the tile
       content or the tiles-per-row setting turns out to be. */
    function measure() {
      alignRows();
      var fits = track.scrollWidth <= track.clientWidth + 1;
      root.classList.toggle('is-static', fits);
      updateArrows();
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth;
      prevBtn.classList.toggle('is-hidden', track.scrollLeft <= 5);
      nextBtn.classList.toggle('is-hidden', track.scrollLeft >= max - 5);
    }

    function step(direction) {
      var tile = tiles[0];
      if (!tile) return;
      var gap = parseInt(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap, 10) || 0;
      track.scrollBy({ left: direction * (tile.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', measure);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(measure).observe(track);
    } else {
      window.setTimeout(measure, 200);
    }
    measure();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(function () {});
    }

    /* ---- Slider: drag to scroll ----
       Suppresses the click that follows a real drag, so dragging across a
       product link or a toggle does not fire it. */
    var down = false, moved = false, startX = 0, startScroll = 0;

    track.addEventListener('mousedown', function (e) {
      if (root.classList.contains('is-static')) return;
      if (e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.pageX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!down) return;
      var delta = e.pageX - startX;
      if (Math.abs(delta) > DRAG_THRESHOLD) moved = true;
      if (moved) {
        e.preventDefault();
        track.scrollLeft = startScroll - delta;
      }
    });

    function endDrag() {
      down = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    track.addEventListener('click', function (e) {
      if (!moved) return;
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }, true);

    /* ---- Add the routine to the cart ---- */
    if (cta) {
      cta.addEventListener('click', function () {
        var chosen = selectedTiles();
        if (!chosen.length) return;

        var items = chosen.map(function (t) {
          return { id: parseInt(t.getAttribute('data-ck-variant'), 10), quantity: 1 };
        }).filter(function (i) { return i.id; });

        if (!items.length) return;

        if (errEl) errEl.hidden = true;
        cta.classList.add('is-loading');
        cta.disabled = true;

        fetch(cartUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add failed: ' + res.status);
            return res.json();
          })
          .then(function () {
            refreshCart();
          })
          .catch(function (err) {
            if (window.console) console.warn('[ck-routine]', err);
            if (errEl) errEl.hidden = false;
          })
          .then(function () {
            cta.classList.remove('is-loading');
            cta.disabled = false;
            updateCta();
          });
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ck-routine]');
    Array.prototype.forEach.call(roots, initRoutine);
  }

  window.ckRoutineInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders a section without a page load.
  document.addEventListener('shopify:section:load', initAll);
})();